"use client";

import { useQuery } from "@tanstack/react-query";

import {
  getLocationAndProvidersMappingInstructions,
  LocationProvidersResponse,
} from "@/src/requests/location-providers-instructions";

export function useLocationAndProvidersInstructions(locationId: string | null) {
  return useQuery<LocationProvidersResponse>({
    queryKey: ["location-providers-instructions", locationId],
    queryFn: () => getLocationAndProvidersMappingInstructions(locationId!),
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
